import { useCallback } from 'react';
import PropTypes from 'prop-types';
// Import Components
import DynamicVariables from './DynamicVariables';
import SMSContent from './SMSContent';
import TemplateCategoryInput from './TemplateCategoryInput';
// Import Enums
import { TemplateTypeEnum } from 'enums';
// Import Constants
import { TemplateInputTypes } from 'constants/common';
import { DefaultLanguage } from 'constants/template';
// Import Hooks
import useBind from 'hooks/UseBind';
import useInputInsertion from 'hooks/UseInputInsertion';

const SMSTemplateContent = ({
    templateData,
    handleChange,
    templateLangKey,
    dynamicVariables,
    maxSMSPartsCount,
    shortenerAndTrackerSettings,
    eventId,
}) => {
    const categoryValue = templateData?.[TemplateInputTypes.Category];

    const handleCategoryChange = useBind(handleChange, TemplateInputTypes.Category);
    const { insertionHandler, updateInsertionHandler, insertionOptions, setInsertionOptions } = useInputInsertion();

    const updateDynamicVariableOptionsSMS = useCallback(() => {
        setInsertionOptions({
            channel: TemplateTypeEnum.SMS,
            inputFilterKey: '',
            hintText: '',
            focusedInputKey: TemplateInputTypes.Body,
        });
    }, [setInsertionOptions]);

    return (
        <>
            <div>
                <DynamicVariables
                    dynamicVariables={dynamicVariables}
                    clickHandler={insertionHandler}
                    insertionOptions={insertionOptions}
                />
            </div>
            <div className="crm-sms-content-wrapper">
                <div className="crm-create-template-page-c-c-h-inputs-row">
                    {templateLangKey === DefaultLanguage && (
                        <TemplateCategoryInput value={categoryValue} onChange={handleCategoryChange} />
                    )}
                </div>
                <div className="crm-sms-main-content">
                    <SMSContent
                        bodyPropertyName={TemplateInputTypes.Body}
                        templateData={templateData}
                        templateLangKey={templateLangKey}
                        maxSMSPartsCount={maxSMSPartsCount}
                        handleChange={handleChange}
                        shortenerAndTrackerSettings={shortenerAndTrackerSettings}
                        updateDynamicVariableOptions={updateDynamicVariableOptionsSMS}
                        updateInsertionHandler={updateInsertionHandler}
                        shouldFocusOnMount={true}
                        isAiAssistantEnabled={true}
                        eventId={eventId}
                    />
                </div>
            </div>
        </>
    );
};

SMSTemplateContent.propTypes = {
    templateData: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    templateLangKey: PropTypes.string.isRequired,
    dynamicVariables: PropTypes.arrayOf(PropTypes.object),
    maxSMSPartsCount: PropTypes.number,
    shortenerAndTrackerSettings: PropTypes.array,
    eventId: PropTypes.number,
};

SMSTemplateContent.defaultProps = {
    shortenerAndTrackerSettings: [],
};

export default SMSTemplateContent;
